import { Images } from "../../../../Images";
import MineControl from "../../../../model/control/MineControl";
import MineMode from "../../../../model/control/MineMode";
import Page from "../../../framework/Page";
import View from "../../../framework/View";

export default class MineModeOption extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {MineControl} mineControl
     * @param {MineMode} mineMode
     * @param {string} topRowText
     * @param {string} bottomRowText
     */
    constructor(parentId, elementId, mineControl, mineMode, topRowText, bottomRowText) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {MineControl}
         */
        this.mineControl = mineControl;
        /**
         * @constant
         * @type {MineMode}
         */
        this.mineMode = mineMode;

        /**
         * @constant
         * @type {string}
         */
        this.topRowText = topRowText;
        /**
         * @constant
         * @type {string}
         */
        this.bottomRowText = bottomRowText;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {boolean}
         */
        this.displayedActive = false;
    }

    /**
     * @override
     */
    initializeView() {
        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('MineModeOption.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.displayedActive = this.mineControl.activeMode === this.mineMode;

        this.mainElement = Page.createElement('div', parent, id, this.displayedActive ? 'mine-mode-button-outer-active' : 'mine-mode-button-outer-not-active');

        const bodyElement = Page.createElement('div', this.mainElement, null, 'mine-mode-button-row');

        const iconElement = Page.createElement('div', bodyElement, null, 'icon-container');

        const imgElement = Page.createElement('img', iconElement, null, 'icon-container'); // 'pick-upgrade-icon'
        imgElement.src = Images.pick;

        // Title/Description container
        const titleDescriptionContainer = Page.createElement('div', bodyElement, null, 'pick-upgrade-title-description-container');

        const topRowElement = Page.createElement('div', titleDescriptionContainer, null, null); //'pick-upgrade-button-title-single-row'
        topRowElement.innerHTML = this.topRowText;

        const bottomRowElement = Page.createElement('div', titleDescriptionContainer, null, 'mined-upgrade-button-description'); //'pick-upgrade-button-title-single-row'
        bottomRowElement.innerHTML = this.bottomRowText;


        //////////////////////////////////////
        // Button Click
        //////////////////////////////////////

        const thisRef = this;
        this.mainElement.onclick = function() {
            console.log('MineModeOption click mode=' + thisRef.mineMode.id);
            thisRef.mineControl.setModeActive(thisRef.mineMode);
        };

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {

        const activeMode = this.mineControl.activeMode === this.mineMode;
        if (this.displayedActive !== activeMode) {
            this.displayedActive = activeMode;

            if (activeMode) {
                this.mainElement.className = 'mine-mode-button-outer-active';
            }
            else {
                this.mainElement.className = 'mine-mode-button-outer-not-active';
            }
        }
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }
}